import * as React from 'react';
import './ItemLoader.scss';

const ItemLoader = () => {
  return (
    <div className="rp-item-loader">
      <span className="square" />
      <div className="rp-item-loader--details">
        <span className="loading-bar" />
        <span className="loading-bar" />
        <span className="loading-bar" />
      </div>
      <div className="rp-item-loader--marks">
        <span className="loading-thick-bar" />
        <span className="loading-thick-bar" />
      </div>
      <div className="rp-item-loader--buttons">
        <span className="loading-medium-bar" />
        <span className="loading-medium-bar" />
      </div>
    </div>
  );
};

export default ItemLoader;
